@use "@design/design-tokens/border-radius/border-radius" as *;

.flexRowWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  gap: 4px;
}

.skeletonLoaderWrapper {
  display: flex;
  justify-content: flex-end;
}

.naFallback {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.indicator {
  margin-left: 10px;
  border-radius: border-radius(full);
  width: 8px;
  height: 8px;
}

.disabled {
  color: var(--text-disabled);
}

.indicatorDefault {
  background-color: var(--text-soft);
}

.indicatorLivePrice {
  background-color: var(--viz-bullish);
}
